import Controller from "./editableSelect.controller";
import template from "./editableSelect.html";

const editableSelect = {
  template,
  controller: Controller,
  bindings: {
    multiple: "<",
    objectReferenceProperty: "@",
    isObject: "<",
    onPressEdit: "<",
    optionDisabled: "@",
    selected: "=",
    list: "<",
    title: "@",
    name: "@",
    eventName: "<",
    hideEdit: "<",
    permissionName: "@",
    resourceMethod: "@",
    resourceMethodName: "@",
    extraParams: "<",
    selectedKey: "@",
    errorMsg: "@",
    isRequired: "<",
    onFieldChangeEvent: "<?",
  },
};

export default editableSelect;



// WEBPACK FOOTER //
// ./src/components/editableSelect/editableSelect.component.js